/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Bulk_Carrier_DetailInputs */



/**
* | output |
* | --- |
* | "Dry-bulk vetting inspections carried out with the RightShip Inspection and Assessment (RISQ) questionnaire. Performed for RightShip and OCIMF members, they a..." |
*
* @param {Service_Bulk_Carrier_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_bulk_carrier_detail = /** @type {((inputs?: Service_Bulk_Carrier_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Bulk_Carrier_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("采用 RightShip 检查与评估（RISQ）问卷开展的干散货审查检查。检查为 RightShip 及 OCIMF 成员执行，在租约敲定前评估散货船的状况、安全和管理。")
	return /** @type {LocalizedString} */ ("Dry-bulk vetting inspections carried out with the RightShip Inspection and Assessment (RISQ) questionnaire. Performed for RightShip and OCIMF members, they assess the condition, safety and management of bulk carriers before a fixture is agreed.")
});